module.exports = __webpack_public_path__ + "static/img/11.8fb80fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/生活照/11.jpg
// module id = Ti/1
// module chunks = 0